import { useLocation } from 'react-router-dom';

import { useSieMethods } from '@/hooks/use-sie';

type Props = {
  readonly className?: string;
  // When set, looks up `${keyPrefix}${pathname}` first, then falls back to `pathname`.
  // This allows namespaced content (e.g. "landing:/sign-in") to coexist with default content.
  readonly keyPrefix?: string;
};

const CustomContent = ({ className, keyPrefix }: Props) => {
  const { customContent } = useSieMethods();
  const { pathname } = useLocation();

  const customHtml =
    (keyPrefix && customContent?.[`${keyPrefix}${pathname}`]) ?? customContent?.[pathname];

  if (!customHtml) {
    return null;
  }

  try {
    // Expected error; CustomContent content is load from Logto remote server
    // eslint-disable-next-line react/no-danger
    return <div dangerouslySetInnerHTML={{ __html: customHtml }} className={className} />;
  } catch {
    return null;
  }
};

export default CustomContent;
